import { timelineItems } from "@/mocks/home";

export default function TimelineSection() {
  return (
    <section id="timeline" className="bg-background-50">
      <div className="mx-auto max-w-[1180px] px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-[0.7fr_1.3fr] gap-8 lg:gap-14">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-label text-primary-600">
              <i className="ri-git-commit-line" aria-hidden="true"></i>
              事件汇总
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-[30px] font-bold text-foreground-950 leading-tight">
              从第一条爆料
              <br />
              到今天
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-600">
              把散落的爆料按时间串起来，标注哪些已有多方印证、哪些仍停留在猜测阶段，帮助你在信息洪流里保持判断。
            </p>
            <a
              href="#collections"
              className="mt-6 h-11 px-5 rounded-md border border-foreground-300 text-foreground-800 text-sm font-label inline-flex items-center gap-2 hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              <i className="ri-file-list-3-line" aria-hidden="true"></i>
              导出懒人时间线
            </a>
          </div>

          <ol className="relative border-l border-background-300 ml-3 md:ml-4">
            {timelineItems.map((item, idx) => (
              <li key={item.date} className="relative pl-7 pb-8 last:pb-0">
                <span
                  className={`absolute -left-[7px] top-1 w-3.5 h-3.5 rounded-full border-2 border-background-50 ${
                    idx === timelineItems.length - 1 ? "bg-primary-500" : "bg-accent-500"
                  }`}
                ></span>
                <div className="flex items-center gap-3">
                  <span className="font-heading text-sm font-bold text-foreground-900 tabular-nums">{item.date}</span>
                  <span className="h-px flex-1 bg-background-200"></span>
                </div>
                <h3 className="mt-2 text-[15px] font-medium text-foreground-950">{item.title}</h3>
                <p className="mt-1.5 text-sm leading-6 text-foreground-600">{item.desc}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}